<a
    class="flex h-full flex-col bg-white md:min-h-[460px]"
    [hyundaiRouterLink]="link()"
    (click)="$event.stopPropagation(); track(); vehicleCardClicked.emit()"
>
    <div
        class="text-extra-dark border-grey-200 bg-grey-500 relative flex aspect-[100/75] max-h-[580px] w-full shrink-0 items-center justify-center overflow-hidden border-b-1 xl:min-h-[292px]"
    >
        @if (!imageError() && image(); as image) {
            <ui-m000-c010-image
                class="contents"
                [alt]="`${vehicle().name} Vorschau Bild`"
                [image]="image"
                [highRes]="true"
                (onError)="imageError.set(true)"
                priority="false"
                classList="w-full"
            />
        } @else {
            Derzeit kein Bild vorhanden
        }
    </div>
    <div class="flex h-full flex-1 cursor-pointer flex-col gap-6 px-24 py-12">
        <div class="flex items-start justify-between gap-12">
            <div>
                <p class="text-18 line-clamp-2 leading-27 font-medium wrap-break-word">
                    {{ vehicle().shortName }}
                </p>
                <p>{{ vehicle().descriptionWithoutModel }}</p>
            </div>
            <lib-vehicle-favorite-button [slug]="vehicle().slug" />
        </div>
        <p class="text-16 mb-12 leading-27">{{ tags() }}</p>
    </div>

    <div class="flex h-full flex-1 cursor-pointer flex-col px-24 py-12">
        <div class="mb-auto flex h-full flex-1 flex-col justify-between gap-8">
            <div class="flex min-h-[15px] flex-wrap items-center gap-12">
                @if (vehicle().meta.promise) {
                    <span
                        role="button"
                        class="bg-accent text-12 flex items-center gap-6 px-8 py-2 text-white"
                        (click)="openPromiseOverlay(); $event.preventDefault(); $event.stopPropagation()"
                        tabindex="0"
                        (keydown.enter)="openPromiseOverlay()"
                    >
                        Hyundai Promise
                        <i class="icon-info"></i>
                    </span>
                }
                @if (vehicle().meta.batteryCertified && vehicle().meta.isPromisePartner) {
                    <span
                        class="bg-grey-200 text-12 flex items-center gap-6 px-8 py-2 text-black"
                        (click)="openBatteryOverlay(); $event.preventDefault(); $event.stopPropagation()"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="openBatteryOverlay()"
                    >
                        Batterie Zertifikat
                        <i class="icon-info"></i>
                    </span>
                }
            </div>

            <div class="mt-auto flex grow flex-col justify-between pb-12">
                <span class="text-16 text-accent flex items-center gap-6 font-medium">
                    <i class="icon-location"></i>
                    {{ vehicle().location.city }}
                </span>
                <p class="flex items-center leading-21">
                    <span>{{ vehicle().envkvString }}</span>
                </p>
            </div>
        </div>
        <div class="border-grey-200 mt-auto flex items-center justify-between gap-12 border-t pt-8">
            <div class="flex items-center gap-12">
                <span class="font-headline text-16 leading-22 font-medium whitespace-nowrap">
                    <span [innerHTML]="(rateFootnoteSource() | footnotes)()"></span>
                </span>
                @if (vehicle().hotDeal) {
                    <div class="bg-blue text-12 flex px-8 py-2 text-white">Angebotspreis</div>
                }
            </div>
            @if (vehicle().priceOld) {
                <span class="font-text text-12 leading-20 font-normal">
                    vorher:
                    <span class="whitespace-nowrap">{{ vehicle().priceOld | currency: 'EUR' : '' : '1.0-0' }} EUR</span>
                </span>
            }
        </div>
    </div>
</a>
